import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import Environment from '../environment';

const firebaseApp = initializeApp({
  apiKey: Environment.FIREBASE_API_KEY,
});

export const firebaseAuth = getAuth(firebaseApp);
